
<div class="col-xs-12 pl-0">
  <input class="form-control" type="text" placeholder="Type here to search..." matInput="matInput" name="addInternalUser" autocomplete="off" [formControl]="autoCompleteInternalUserController" [matAutocomplete]="internalUserAuto"/>
  <mat-autocomplete class="search-bar-xs" #internalUserAuto="matAutocomplete">
    <mat-option class="bg-white" *ngFor="let option of internalUserOptions | async" [value]="option.name" (onSelectionChange)="autoCompleteOnInternalUserSelect(option)">{{option.name}}</mat-option>
  </mat-autocomplete>
</div>